export enum GenesysCloudAPIRegionGroup {
  Americas = 'Americas',
  Europe = 'Europe',
  MiddleEast = 'Middle East',
  AsiaPacific = 'Asia Pacific',
}
